import axios from 'axios';

export const get = (query: string, limit: number, page: number) =>
    axios.get('/keys', { params: { query, limit, page } });

export const generate = (amount: number | null, plan: string, type: string, reseller_type: string = '') =>
    axios.post('/keys', { amount, plan, type, reseller_type: reseller_type || null });

export const destroy = (id: number) =>
    axios.delete(`/keys/${id}`);

export const redeem = (key: string) =>
    axios.post(`/keys/redeem/${key}`);

export const redeemAdvanced = (key: string) =>
    axios.post(`/keys/redeem/advanced/${key}`);

// New API to fetch reseller summary data
export const getResellerSummary = () =>
    axios.get('/keys/reseller-summary');
